import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SharedService } from "../../services/shared.service";

@Component({
  selector: 'app-VetProfilePage',
  templateUrl: './vet_profile.page.html',
  styleUrls: ['./vet_profile.page.scss'],
})

export class VetProfilePage {

  @Input() profile: any;
  private locality: any;
  private administrative_area_level_1: any;

  constructor(
    private sharedService: SharedService,
    private modalController: ModalController
  ) {

   }

  ngOnInit() {

    if(this.profile.settings.vetibility_clinic_network == 1) {
      this.profile.vcn_clinic.data = JSON.parse(this.profile.vcn_clinic.data);
    }

    this.profile.location.data.address_components.forEach(component => {
      //alert(component.long_name);
      component.types.forEach(type => {
        if(type == 'locality') {
          this.locality = component.long_name;

        } else if(type == 'administrative_area_level_1') {
          this.administrative_area_level_1 = component.long_name;
        }
      });
    });

  }

  ionViewWillLeave() {

  }

  dismiss() {
    this.modalController.dismiss();
  }

}
